// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { error } from 'react-notification-system-redux'
import { updateInterferenceAnalysisState } from 'redux/modules/interferenceAnalysis'
import { UNCAUGHT_ERROR } from 'errors'
import {
  fetchAFSProtectionType,
  fetchAnalysisTypes,
  fetchPropagationModels,
} from 'helpers/api'

// Keeps track of enums specific to IA/AFS.

const loadAnalysisSettings = () => async (dispatch, getState) => {
  // if we've already got the settings loaded, we can skip this part.
  if (getState().interferenceAnalysis.get('analysisTypes').size !== 0) {
    return
  }

  try {
    const r = await Promise.all([
      fetchAnalysisTypes(),
      fetchAFSProtectionType(),
      fetchPropagationModels(),
    ])

    const analysisTypes = r[0].entities
    const protectionTypes = r[1].entities
    const propagationModels = r[2].entities

    await dispatch(updateInterferenceAnalysisState({
      analysisTypes,
      protectionTypes,
      propagationModels,
    }))
  } catch (err) {
    console.warn(err)

    // if the settings didn't load properly,then we wont be able to render the
    // IA/AFS UI properly.
    dispatch(error({
      title: 'Analysis Settings Error',
      message: err.message || UNCAUGHT_ERROR,
      dismissible: false,
      autoDismiss: 0,
      action: {
        label: 'Reload page.',
        callback: () => window.location.reload(),
      },
    }))

    // throwing this error cancels the initialization process
    throw error
  }
}

export default loadAnalysisSettings
